import { render } from "./OrientationPanel.vue?vue&type=template&id=1af042a3"
import script from "./OrientationPanel.vue?vue&type=script&lang=js"
export * from "./OrientationPanel.vue?vue&type=script&lang=js"

import exportComponent from "/builds/arkindex/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__